import React, { LabelHTMLAttributes } from 'react';
import { Radio } from 'src/core/forms';
import classnames from 'classnames';
import { NEW_ARTWORK_ID } from 'src/constants/artwork';

import classes from './AddNewLogo.scss';

type AddNewLogoProps = {
    id: string;
    description?: string;
    setNewLogo: (state: boolean) => void;
} & LabelHTMLAttributes<any>;

export const AddNewLogo: React.FC<AddNewLogoProps> = (props) => {
    const { id, description, setNewLogo } = props;

    return (
        <div onClick={() => setNewLogo(true)} className={classes.wrapper}>
            <Radio className={classes.input} value={NEW_ARTWORK_ID} id={id} />
            <label className={classnames(classes.label, classes.addNew_label)} htmlFor={id}>
                <div className={classes.addNew}>
                    <p className={classes.addNew_desc}>{description}</p>
                </div>
            </label>
        </div>
    );
};
